module.exports = __webpack_public_path__ + "img/exam_jan_2025_m4g610mc.d7ee5cd4.jpg";